import React, {useEffect} from "react";
import PublicationFacet from "./yearbookSearchFacet/yearbookSearchFacet";
import "./yearbookSearchFacets.scss";
import {useDispatch} from "react-redux";
import {setFacets, setPage} from "../../store/yearbook/yearbookSearchSlice";
import i18next from "i18next";

const YearbookSearchFacets = ({props}) => {

    const { data } = props;

    const [searchFacets, setSearchFacets] = React.useState({});

    const dispatch = useDispatch();

    // useEffect(() => {
    //     const sidebar = document.querySelector('.chapter-sidebar');
    //     const sidebarOffCanvas = new bootstrap.Offcanvas(sidebar, {backdrop: false, scroll: true});
    //     document.querySelector('.sidebar-toggle').addEventListener('click', function(event) {
    //         event.preventDefault();
    //         sidebarOffCanvas.toggle();
    //     });
    // });

    const onFacetChanged = (facetChangeEvent) => {
        let currentFacets = {...searchFacets};
        if (facetChangeEvent.facet_entry.selected) {
            currentFacets[facetChangeEvent.facet_key] = facetChangeEvent.facet_entry.facet;
        } else {
            delete currentFacets[facetChangeEvent.facet_key];
        }
        setSearchFacets(currentFacets);
        dispatch(setFacets(currentFacets));
        dispatch(setPage(1));
    }

    return (
        <>
            {
                data ?
                    <div className={'col col-md-3 chapter-sidebar offcanvas offcanvas-end mt-0'}>
                        <h4>{i18next.t('yearbook.filter_by', 'Filter by')}</h4>
                        <div className="px-0 px-md-0">
                            <div className="side-facet">
                                {data ? Object.entries(data?.facets_expanded).map(
                                    ([key, facetList]) =>
                                        <>
                                            {
                                                facetList.length > 0 &&
                                                <PublicationFacet
                                                    facet={{facetKey: key, facetList: facetList}}
                                                    onFacetChange={onFacetChanged}>
                                                </PublicationFacet>
                                            }
                                        </>
                                ) : null}
                            </div>
                        </div>
                    </div>
                : null
            }
        </>
    )
}

export default YearbookSearchFacets;
